import script from "./MoveMembersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveMembersModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import NeueButton from "@/components/neue/NeueButton.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { HighlightedText, NeueButton, SelectInput, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HighlightedText, NeueButton, SelectInput, TheModal }, script.__o.components);}